<template>
  <div class="k7-banner">
    <div class="company-block">
      <div class="company-logo-block">
        <div class="company-titles">
          <div class="main-title">Notaðir bílar</div>
          <div class="sub-title">á nýju plani</div>
        </div>
        <div class="map-pointer">
          <img :src="getBaseUrl + '/img/k7/map_pointer.svg'"/>
        </div>
      </div>

      <div class="k7-company-logos">
        <div class="company-logo" v-for="(banner,index) in banners" :key="index">
          <img :src="getBaseUrl + '/img/k7/logo/'+banner.url">
        </div>
      </div>
    </div>


    <a target="_blank" href="https://goo.gl/maps/CziyxNCvqcakeCwWA" class="map-banner">
      <img :src="getBaseUrl + '/img/k7/map.svg'"/>
    </a>
  </div>
</template>

<script>
import getBaseUrl from "@/helpers/getBaseUrl";
export default {
  data: () => ({
    banners: [
      {
        url: 'askja.svg'
      }, {
        url: 'bilaland.svg'
      }, {
        url: 'bilam.svg'
      }, {
        url: 'bilabankinn.svg'
      },
      {
        url:'hyundai.svg'
      }
    ]
  }),
  computed:{
    getBaseUrl(){
      return getBaseUrl();
    }
  }
}
</script>